import React from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import NavBar from './components/NavBar';
import Projects from './components/Projects';
import Profile from './components/Profile';
import About from './components/About';
import Skills from './components/Skills';
import "./App.css";

function ShowProjectsButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const isProjectsPage = location.pathname === '/projects';

  const toggleProjects = () => {
    if (isProjectsPage) {
      navigate('/'); 
    } else {
      navigate('/projects');
    }
  };

  return (
      <button className="toggle-projects btn btn-primary" onClick={toggleProjects}>
        {isProjectsPage ? 'Hide Projects' : 'Show Projects'}
      </button>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <NavBar />
              <Profile />        
              <ShowProjectsButton />
            </>
          } />          
          <Route path="/projects" element={
             <>
              <NavBar />
              <Projects/>  
              <ShowProjectsButton/>
              </> 
          } />
          <Route path="/about" element={
           <> 
          <NavBar />
          <About />
          </> 
        } />
          <Route path="/skills" element={
          <> 
          <NavBar />
          <Skills />
          </> 
        } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;